import { FC, ReactNode } from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, LinkProps } from 'react-router-dom';

import { ButtonSizeVariants, ButtonSizeVariantsStyles, ButtonVariants, ButtonVariantStyles } from 'constants/common';
import { cn } from 'utils/global';

interface Props extends LinkProps {
  children: ReactNode;
  className?: string;
  variant?: ButtonVariants;
  to: string;
  size?: ButtonSizeVariants;
  icon?: IconProp;
}

const LinkButton: FC<Props> = ({
  children,
  variant = ButtonVariants.PRIMARY,
  className,
  to,
  size = ButtonSizeVariants.LG,
  icon,
  ...props
}) => {
  return (
    <Link
      to={to}
      className={cn('flex items-center', ButtonVariantStyles[variant], ButtonSizeVariantsStyles[size], className)}
      {...props}
    >
      <div className="flex items-center space-x-2">
        {icon && <FontAwesomeIcon icon={icon} />}
        <span>{children}</span>
      </div>
    </Link>
  );
};

export default LinkButton;
